import * as Styles from "./style.js";

export const Categories = (props) => {
  return (
    <>
      <Styles.Button onClick={props.onClick}>{props.title}</Styles.Button>
    </>
  );
};
